import { Navigate, useRoutes } from 'react-router-dom';
import { userAfterLoginRoutes } from '@src/domains/user-after-login/routes';

import { helpRoutes } from './pages/help';
import { mainRoutes } from './sections/main';
import { authRoutes } from './sections/auth';
import { landingRoutes } from './sections/landing';
import { dashboardRoutes } from './pages/dashboard';
import { userProfileRoutes } from './pages/user-profile';
import { userAccountRoutes } from '../domains/user-account/routes';
import { companyRoutes } from '../domains/business/company/routes';
import { supportTicketRoutes } from '../domains/support-ticket/routes';
// Note: company-project, company-partner, company-project-action,
// company-project-category, company-managment-dashboard, and reports routes
// are nested inside dashboardRoutes (see ./pages/dashboard) so they share one
// AuthGuard/OnboardingGuard/DashboardLayout/Suspense instance instead of each
// declaring its own.
// --------------------------------------W--------------------------------

export default function Router() {
  return useRoutes([
    // Landing routes
    ...landingRoutes,
    // Auth routes
    ...authRoutes,
    // Dashboard Routes
    ...dashboardRoutes,
    // Main routes
    ...mainRoutes,
    // User After Login
    ...userAfterLoginRoutes,
    // User Profile Routes
    ...userProfileRoutes,
    // User Account Routes
    ...userAccountRoutes,
    // Company Routes
    ...companyRoutes,
    // Support Ticket Routes
    ...supportTicketRoutes,
    // Help routes
    ...helpRoutes,
    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
